// src/constants/messages.js
const ERROR_MESSAGES = {
  DEFAULT: "Something went wrong. Please try again later.",
  NETWORK: "Unable to connect. Please check your network connection.",
  UNAUTHORIZED: "Your session has expired. Please log in again.",
  FAMILY_NOT_FOUND: "Family not found. Please check the Family ID.",
  INVALID_INPUT: "Invalid input provided.",
};

export default ERROR_MESSAGES;
